import { assertProjectOpsAddendumEditable, getProjectOpsFromWorkItem } from "./projectOpsUtils";
import { computeBudgetAwarePricingTotal } from "./pricingTotalUtils";

// Review stored contract prices. Never reprice or normalize frozen documents.
export function getIchAddendumReview(contract, number) {
	const documents = contract && Array.isArray(contract.documents) ? contract.documents : [];
	const drafts = documents.filter(document => document && document.kind === "addendum" && document.status === "draft");
	const document = drafts.find(candidate => Number(candidate.number) === Number(number));
	if (!document || drafts.length !== 1 || !Number.isSafeInteger(Number(number)) || Number(number) < 1) {
		throw new Error(`No unique saved draft for Addendum ${number} is available. Refresh the dashboard after saving your selections.`);
	}
	// Dashboard operations target the chosen round, independently of which document
	// was last viewed or which round the structural session last resumed.
	assertProjectOpsAddendumEditable({ ...contract, activeDocumentId: document.id }, {
		addendumNumber: Number(number), structuralAddendumLimit: Number(number)
	});
	const baseline = documents.find(candidate => candidate.id === document.baseDocumentId);
	const baselineTotal = computeBudgetAwarePricingTotal(baseline.invoiceItems || []);
	const proposedTotal = computeBudgetAwarePricingTotal(document.invoiceItems || []);
	return { document, baseline, baselineTotal, proposedTotal, delta: +(proposedTotal - baselineTotal).toFixed(2) };
}

export function getIchDashboardAddendumNumber(row, instance, stages = []) {
	if (!row || row.pending || !row.url) return null;
	const documents = instance && instance.pricingContractProto && instance.pricingContractProto.documents;
	if (Array.isArray(documents)) {
		const draft = documents.find(document => document && document.kind === "addendum" && document.status === "draft");
		return draft ? Number(draft.number) : null;
	}
	if (row.contract && row.contract.documentKind === "addendum" && row.contract.documentStatus === "draft") {
		return Number(row.contract.documentNumber) || null;
	}
	const stage = stages.find(candidate => {
		const context = getProjectOpsFromWorkItem(candidate.workItem || {});
		return ["open", "in_progress"].includes(candidate.status) && context.addendumNumber
			&& !(row.values || {})[`addendum${context.addendumNumber}`];
	});
	return stage ? Number(getProjectOpsFromWorkItem(stage.workItem).addendumNumber) : null;
}
